import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const Icon = styled.i`
  color: #dbdbdb;
  font-size: 16px;
  margin-right: 9px;
  margin-top: 1px;
`
const Container = styled.div`
  font-size: 28px;
`

const Props = {
  onClick: PropTypes.func,
  className: PropTypes.string,
}
const RightArrow = ({ onClick, className }) => {
  return (
    <Container
      className={className}
      role="button"
      tabIndex={0}
      onClick={onClick}
    >
      <Icon className="fas fa-chevron-right" />
    </Container>
  )
}
RightArrow.propTypes = Props

export default RightArrow
